<div class="campanhas-page integracao-gestao-page">
  <app-back-button routerLink="/integracao" label="Voltar para integração" data-testid="integracao-gestao-voltar" />

  <!-- O h1 é a seção, como na tela anterior; a campanha vem logo abaixo, com id e nome, e as
       datas que a delimitam fecham o cabeçalho. -->
  <app-page-header title="Integração">
    <div meta class="integracao-gestao__identificacao">
      @if (tituloCampanha(); as campanha) {
        <p class="integracao-gestao__campanha" data-testid="integracao-gestao-campanha">
          {{ campanha }}
        </p>
      }

      <div class="integracao-gestao__linha">
        <dl class="integracao-gestao__datas">
          @if (periodoCampanha(); as periodo) {
            <div class="integracao-gestao__data">
              <dt class="integracao-gestao__data-rotulo">Período da campanha</dt>
              <dd class="integracao-gestao__data-valor" data-testid="integracao-gestao-periodo">
                {{ periodo }}
              </dd>
            </div>
          }
          @if (inicioVigencia(); as vigencia) {
            <div class="integracao-gestao__data">
              <dt class="integracao-gestao__data-rotulo">Início da vigência</dt>
              <dd class="integracao-gestao__data-valor" data-testid="integracao-gestao-vigencia">
                {{ vigencia }}
              </dd>
            </div>
          }
        </dl>
        @if (proveniencia(); as texto) {
          <span class="integracao-gestao__proveniencia" data-testid="integracao-gestao-proveniencia">
            <span class="integracao-gestao__proveniencia-marcador" aria-hidden="true"></span>
            {{ texto }}
          </span>
        }
      </div>
    </div>

    <ng-container actions>
      <div class="actions-menu" [class.actions-menu--open]="relatoriosMenuAberto()">
        <button
          type="button"
          class="btn-outline-primary btn-toolbar"
          data-testid="btn-relatorios"
          [attr.aria-expanded]="relatoriosMenuAberto()"
          aria-haspopup="true"
          [disabled]="baixandoRelatorio()"
          (click)="toggleRelatoriosMenu($event)"
        >Relatórios</button>
        @if (relatoriosMenuAberto()) {
          <div class="actions-menu-dropdown" role="menu">
            <button
              type="button"
              role="menuitem"
              data-testid="relatorio-option-pdf"
              (click)="onRelatorio(RelatorioFormato.Pdf)"
            >
              Baixar em PDF
            </button>
            <button
              type="button"
              role="menuitem"
              data-testid="relatorio-option-excel"
              (click)="onRelatorio(RelatorioFormato.Excel)"
            >
              Baixar em Excel
            </button>
          </div>
        }
      </div>
      <button
        type="button"
        class="btn-outline-primary btn-toolbar"
        data-testid="btn-config-de-para"
        (click)="onAbrirDePara()"
      >Configurar Integração Amadeus</button>
      <!-- Funcionalidade em análise -->
      <!-- <button
        type="button"
        class="btn-outline-primary btn-toolbar"
        data-testid="btn-log-integracao"
        (click)="onLogClick()"
      >Log de integração</button> -->
    </ng-container>
  </app-page-header>

  @if (resumoCarga(); as resumo) {
    <app-integracao-resumo-carga class="integracao-gestao__resumo" [resumo]="resumo" />
  }

  @if (cargaIntegrada()) {
    <p class="mt-5 integracao-gestao__concluida" role="status" data-testid="integracao-gestao-concluida">
      Todos os registros desta carga foram integrados com sucesso.
    </p>
  } @else {
    <app-adesao-integracao-filter-bar (filtersChange)="onFiltersChange($event)" />

    @if (adesoes().length === 0) {
      <app-empty-state
        [message]="
          filtroAplicado()
            ? 'Nenhuma adesão encontrada para os filtros aplicados'
            : 'Nenhuma adesão encontrada para esta integração'
        "
      />
    } @else {
      <app-data-table ariaLabel="Adesões da integração">
        <thead>
          <tr>
            <th scope="col">
              <input
                type="checkbox"
                class="integracao-gestao__selecao"
                aria-label="Selecionar todas as adesões aguardando"
                data-testid="selecionar-todos"
                [checked]="todosSelecionados()"
                [disabled]="aguardandoLiberacaoIds().length === 0"
                (change)="toggleSelecionarTodos()"
              />
            </th>
            <th scope="col">Nome</th>
            <th scope="col">Matrícula</th>
            <th scope="col">Registro</th>
            <th scope="col">Plano</th>
            <th scope="col">Perfil Anterior</th>
            <th scope="col">Novo Perfil</th>
            <th scope="col">Status</th>
            <th scope="col">Dt. de Integração</th>
            <th scope="col"><span class="visually-hidden">Ações</span></th>
          </tr>
        </thead>
        <tbody>
          @for (adesao of adesoesPaginadas(); track adesao.idPerfilInvestimentoParticipante) {
            <tr>
              <td>
                <input
                  type="checkbox"
                  class="integracao-gestao__selecao"
                  [attr.aria-label]="'Selecionar ' + adesao.nome"
                  data-testid="selecionar-adesao"
                  [checked]="selecionados().has(adesao.idPerfilInvestimentoParticipante)"
                  [disabled]="!isSelecionavel(adesao)"
                  (change)="toggleSelecao(adesao.idPerfilInvestimentoParticipante)"
                />
              </td>
              <td data-testid="adesao-nome">{{ adesao.nome }}</td>
              <td data-testid="adesao-matricula">{{ adesao.matricula ?? '—' }}</td>
              <td data-testid="adesao-registro">{{ adesao.registro ?? '—' }}</td>
              <td data-testid="adesao-plano">{{ adesao.plano ?? '—' }}</td>
              <td data-testid="adesao-perfil-anterior">{{ adesao.perfilAnterior || '—' }}</td>
              <td data-testid="adesao-perfil-novo">{{ adesao.perfilNovo || '—' }}</td>
              <td><app-status-badge [status]="adesao.status" /></td>
              <td data-testid="adesao-dt-integracao">{{ adesao.dataIntegracao ?? '—' }}</td>
              <td class="actions-cell">
                <div class="actions-menu" [class.actions-menu--open]="menuAbertoId() === adesao.idPerfilInvestimentoParticipante">
                  <button
                    type="button"
                    class="actions-menu-btn"
                    [attr.aria-expanded]="menuAbertoId() === adesao.idPerfilInvestimentoParticipante"
                    aria-haspopup="true"
                    [attr.aria-label]="'Ações para ' + adesao.nome"
                    data-testid="actions-menu-btn"
                    (click)="toggleMenu(adesao.idPerfilInvestimentoParticipante, $event)"
                  >
                    &#8942;
                  </button>
                  @if (menuAbertoId() === adesao.idPerfilInvestimentoParticipante) {
                    <div
                      class="actions-menu-dropdown actions-menu-dropdown--fixed"
                      role="menu"
                      [style.top.px]="menuPosition()?.top"
                      [style.right.px]="menuPosition()?.right"
                    >
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-visualizar-log"
                        (click)="onVisualizarLog(adesao, $event)"
                      >
                        Visualizar log
                      </button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </app-data-table>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize"
        [totalItems]="adesoes().length"
        (pageChange)="onPageChange($event)"
      />

      <div class="integracao-gestao__acoes">
        <button
          type="button"
          class="btn-danger btn-toolbar"
          data-testid="btn-cancelar-selecao"
          [disabled]="selecionados().size === 0"
          (click)="onCancelarSelecao()"
        >Cancelar</button>
        <button
          type="button"
          class="btn-primary btn-toolbar"
          data-testid="btn-liberar"
          [disabled]="selecionados().size === 0 || liberando()"
          (click)="onLiberarClick()"
        >Liberar</button>
      </div>

      @if (mostrarConfirmacaoLiberar()) {
        <app-alert-dialog
          title="Liberar adesões"
          message="Deseja realmente liberar os participantes selecionados?"
          cancelLabel="Cancelar"
          confirmLabel="Liberar"
          [showConfirmIcon]="false"
          (confirm)="onConfirmarLiberar()"
          (cancel)="onCancelarConfirmacaoLiberar()"
        />
      }
    }
  }

  @if (log(); as logAtual) {
    <app-integracao-log-dialog [log]="logAtual" (fechar)="onFecharLog()" />
  }

  @if (logAdesao(); as logDoParticipante) {
    <app-adesao-log-dialog [log]="logDoParticipante" (fechar)="onFecharLogAdesao()" />
  }

  @if (deParaModalAberto()) {
    <app-de-para-config-modal [idCampanha]="idCampanhaNumero()" (close)="onFecharDePara()" />
  }
</div>
